import { css } from '@emotion/react';
import React from 'react';

import { ColorPalette } from './ColorPalette';
import Symbols, { SymbolView } from './Symbols';

export default function SymbolDebugPage(): React.ReactElement {
  const symbols = React.useMemo(() => Object.values(Symbols) as Symbols[], []);

  return (
    <div css={styles.page}>
      <h1 css={styles.header}>Symbols</h1>
      <div css={styles.grid}>
        {symbols.map((symbol) => (
          <div key={symbol} css={styles.item}>
            <div css={styles.symbolBox}>
              <SymbolView symbol={symbol} style={symbolStyle} />
            </div>
            <div css={styles.label}>
              {symbol.toLowerCase().replace(/_/g, ' ')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const symbolStyle: React.CSSProperties = {
  width: 112,
  height: 112,
  objectFit: 'contain',
};

const styles = {
  page: css({
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  }),
  header: css({
    margin: 0,
    fontSize: 24,
    color: ColorPalette.brightText,
  }),
  grid: css({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  }),
  item: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: 150,
    transition: 'color 120ms ease',
  }),
  symbolBox: css({
    border: '1px solid #444',
    backgroundColor: '#10131a',
    transition:
      'background-color 120ms ease, color 120ms ease, border-color 120ms ease',
    ':hover': {
      backgroundColor: '#ffffff',
      borderColor: '#999',
    },
  }),
  label: css({
    fontSize: 9,
    fontWeight: 500,
    color: ColorPalette.normalText,
    overflowWrap: 'anywhere',
    wordBreak: 'break-all',
    width: '100%',
    marginTop: 2,
    alignSelf: 'stretch',
  }),
};
